import { CONFEAR_PERMISSIONS } from '@core/consts/CONFEAR-PERMISSIONS';
import {
  AnaliseNfe,
  ProdutoAnaliseNfe
} from '@core/models/entities/nfe-analise/analise-nfe';
import { DefaultResponse } from '@core/models/responses/default-response';
import { UsuarioCreditos } from '@core/models/responses/usuario/usuario-response';
import { BaseGridComponent } from '@shared/components/base-grid/base-grid';
import { ModalLegendaCustoComponent } from '@shared/components/modais/modal-legenda-custo/modal-legenda-custo.component';
import { PageWrappingComponent } from '@shared/components/page-wrapping/page-wrapping.component';
import { CustoRealPipe } from '@shared/pipes/custo-real/custo-real.pipe';
import {
  DxButtonModule,
  DxDataGridModule,
  DxDropDownButtonModule,
  DxTooltipModule
} from 'devextreme-angular';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'app-nfe-analise',
  templateUrl: './nfe-analise.component.html',
  styleUrls: ['./nfe-analise.component.scss'],
  imports: [
    CommonModule,
    DxDataGridModule,
    PageWrappingComponent,
    DxButtonModule,
    DxDropDownButtonModule,
    Button,
    DxTooltipModule,
    CustoRealPipe,
    TooltipModule,
    ModalLegendaCustoComponent
  ]
})
export class NfeAnaliseComponent
  extends BaseGridComponent<any>
  implements OnChanges, OnInit
{
  @Input() analiseNfeResponse: AnaliseNfe;
  @Input() nfe: any;
  @Input() pageTitle: string;
  @Input() creditos: UsuarioCreditos;
  @Output() nfeLoaded = new EventEmitter<any>();
  override data: DefaultResponse<AnaliseNfe>;
  currentTooltip: number;
  showToggleCustoReal: boolean;
  showModalCostLegend: boolean;
  outrasInformacoes: Partial<AnaliseNfe>;

  async ngOnInit() {
    this.gridPermission = CONFEAR_PERMISSIONS.ANALISAR_NFE;
    await this.loadInitalConfigs();
  }

  ngOnChanges() {
    if (this.analiseNfeResponse) {
      const { produtos, ...rest } = this.analiseNfeResponse;
      this.handleDataSource(produtos);
      this.outrasInformacoes = rest;
    }
  }

  handleDataSource(produtos: ProdutoAnaliseNfe[]) {
    if (produtos) {
      let count = 0;
      this.dataSource = produtos.map(row => {
        return { ...row, idGrid: count++ };
      });
    }
  }

  getClassCoastAlert() {
    if (this.data?.dados?.totalizadores) {
      const { custoTotalValorMedioNota } = this.data?.dados?.totalizadores;

      if (custoTotalValorMedioNota < 0) {
        return 'maior';
      } else if (custoTotalValorMedioNota > 0) {
        return 'menor';
      }

      return 'igual';
    }
  }

  getCoastAlertMessage() {
    if (this.data?.dados?.totalizadores) {
      const { custoTotalValorMedioNota } = this.data?.dados?.totalizadores;

      let value = Math.abs(custoTotalValorMedioNota);
      const result = Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
      if (custoTotalValorMedioNota < 0) {
        return `maior ${result} contra`;
      } else if (custoTotalValorMedioNota > 0) {
        return `menor ${result} contra`;
      }

      return 'igual';
    }
  }

  openProductModal(row) {
    this.modalService.open({
      id: CONFEAR_PERMISSIONS.TODOS,
      name: 'PRODUCT MODAL',
      open: true,
      data: {
        product: row.data,
        nfe: this.nfe
      }
    });
  }

  toggleCustoReal(row) {
    if (row?.data?.valorMedio) {
      this.currentTooltip = row?.data?.idGrid;
      this.showToggleCustoReal = !this.showToggleCustoReal;
    }
  }

  openModalCostLegend() {
    this.showModalCostLegend = true;
  }

  closeModalCostLegend() {
    this.showModalCostLegend = false;
  }

  percentFormat(cell) {
    return (cell?.value * 100).toFixed(2).toString().replace('.', ',');
  }

  isMasterAcode(): boolean {
    return this.authService.isMasterAcode;
  }
}
